// Открытый билет (окно с подробностями)
import type { Currency, Ticket } from '@sayohat/shared';
import { createStore, useStore } from '../../shared/lib/store';
import { track } from '../../shared/lib/track';
import type { SavedQuery } from '../../shared/lib/types';

export interface TicketContext {
  currency: Currency;
  query: SavedQuery;
  /** ссылка на поиск (для «Поделиться» и заявки) */
  searchUrl: string;
}

export const ticketDialogStore = createStore({ ticket: null as Ticket | null, ctx: null as TicketContext | null, open: false, n: 0 });
export const useTicketDialog = () => useStore(ticketDialogStore);

export function openTicket(ticket: Ticket, ctx: TicketContext): void {
  track('view_ticket');
  ticketDialogStore.set((s) => ({ ticket, ctx, open: true, n: s.n + 1 }));
}

export const closeTicket = (): void => ticketDialogStore.set({ open: false });
